/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // hide all sections
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartHeader").classList.remove("active");
    document.querySelector("#miniCartBody").classList.remove("active");
    document.querySelector("#miniCartFooter").classList.remove("active");

    // start loading on the cart
    document.querySelector("#miniCartContent").classList.add("loading");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }


    // stop loading on the cart
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerIconsCart').setAttribute("data-count", cart.item_count);
    document.querySelector("#miniCartHeaderTitle").textContent = `Your Cart (${cart.item_count})`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        return;
    }

    // update price
    document.querySelector("#miniCartFooterCheckoutPrice").textContent = price(cart.total_price, false);

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    if (cartSettings.enable_free_shipping_bar) {
        if (cart.total_price >= freeShippingThreshold) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = `Spend<b> ${price(freeShippingThreshold - cart.total_price)}</b> more for <b>FREE SHIPPING</b>`;
            document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // check if sale enabled
    if (cartSettings.activate_sale) {

        // check local storage to see if they just tried to remove an item with the key matching our variety pack
        if (localStorage.getItem("removeVariety") === "true") {
            // unset local storage
            localStorage.removeItem("removeVariety");
        } else {
            // SALE: If 1 variety packs are in the cart, add 1 more (discount will be automatic to make free)
            let varietyPackID = 9321766682930;
            let varietyPackVariantID = 48595414024498;

            // check if there are 1 variety packs in the cart
            let varietyPackInCart = cart.items.filter(item => item.product_id === varietyPackID);
            if (varietyPackInCart.length === 1) {
                let varietyPackInCartCount = varietyPackInCart[0].quantity;

                // if there is 1 variety pack in the cart and it's not free, add another
                if (varietyPackInCartCount === 1 && varietyPackInCart[0].final_line_price > 0) {
                    // add to cart
                    await addProduct({
                        items: [{
                            id: varietyPackVariantID,
                            quantity: 1
                        }]
                    });

                    // update cart
                    await openCart();
                }
            }
        }

    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = "";

            /****************** discount ******************/

            let comparePrice = null
            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
            }
            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                comparePrice = item.original_line_price;
            }
            // check for compare at price
            else if (variantIDToCompareAtPrice[item.variant_id] > item.final_price) {
                comparePrice = variantIDToCompareAtPrice[item.variant_id] * item.quantity;
            }

            // check if comparePrice exists
            if (comparePrice) {
                HTML += `<s>${price(comparePrice, false)}</s>`;
            }

            /****************** actual price ******************/

            HTML += price(item.final_line_price, false);

            /***************** savings *****************/

            // check for savings
            if (comparePrice) {
                let savings = comparePrice - item.final_line_price;
                if (savings > 0) {
                    HTML += `<span>(Save ${price(savings, false)})</span>`;
                }
            }

            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {
            // check if already a subscription
            if (item.selling_plan_allocation) {
                return "";
            }

            // get selling plan id and name
            let sellingPlanID = variantIDToSellingPlanID[item.variant_id];
            let sellingPlanName = variantIDToSellingPlanName[item.variant_id];

            // check if selling plan exists
            if (!sellingPlanID) {
                return "";
            }

            // return HTML
            return `
                <button 
                    class="miniCartBodyItemUpgrade button blue"
                     data-key="${item.key}"
                     data-id="${item.variant_id}"  
                     data-plan="${sellingPlanID}"
                >
                    ${sellingPlanName}
                </button>
            `;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                            ${propertiesHTML()}
                            ${subscriptionHTML()}
                        </div>
                        <button class="miniCartBodyItemRemove">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.28125 3.28125L3.86719 12.6562C3.89502 13.1979 4.28906 13.5938 4.80469 13.5938H10.1953C10.713 13.5938 11.0997 13.1979 11.1328 12.6562L11.7188 3.28125" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.34375 3.28125H12.6562H2.34375Z" fill="#8F8F8F"></path><path d="M2.34375 3.28125H12.6562" stroke="#8F8F8F" stroke-width="0.9375" stroke-miterlimit="10" stroke-linecap="round"></path><path d="M9.60938 5.15625L9.375 11.7188M5.625 3.28125V2.10938C5.62473 2.01697 5.64273 1.92541 5.67797 1.83998C5.71321 1.75455 5.76499 1.67693 5.83034 1.61159C5.89568 1.54624 5.9733 1.49446 6.05873 1.45922C6.14416 1.42398 6.23571 1.40598 6.32812 1.40625H8.67188C8.76429 1.40598 8.85584 1.42398 8.94127 1.45922C9.0267 1.49446 9.10432 1.54624 9.16966 1.61159C9.23501 1.67693 9.28679 1.75455 9.32203 1.83998C9.35727 1.92541 9.37527 2.01697 9.375 2.10938V3.28125H5.625ZM7.5 5.15625V11.7188V5.15625ZM5.39062 5.15625L5.625 11.7188L5.39062 5.15625Z" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </button>
                    </div>
                    <div class="miniCartBodyItemFlex">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">-</button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">+</button>
                        </div>
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                </div>
                ${upgradeHTML()}
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {

            if (cartSettings.activate_sale && (key === "48595414024498:ebcb008d338291bb36774e810a4cb58c" || key === "48595414024498:a3f2e7c3d4043cd225b3286db6b21bc6" || key === "48595414024498:67fb7b473144778443b6bcb76c20ffee") && quantity === 2) {
                localStorage.setItem("removeVariety", "true");
                quantity--;
                updateCartItem();
            }

            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            // if the sale is running, and they remove the variety pack, we add a local storage item to prevent it from being added back to the cart automatically
            if (cartSettings.activate_sale && (key === "48595414024498:ebcb008d338291bb36774e810a4cb58c" || key === "48595414024498:a6f8b2d1c9f77a9c0767eb3e64f88910" || key === "48595414024498:67fb7b473144778443b6bcb76c20ffee")) {
                localStorage.setItem("removeVariety", "true");
            }


            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // update cart in shopify
            cart = await changeCart({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const variantID = parseInt(this.dataset.id);
            const sellingPlanID = parseInt(this.dataset.plan);

            // add loading animation
            this.classList.add("loading");

            // remove this product from the cart
            await changeCart({
                id: key,
                quantity: 0,
            });

            // add new product to cart (note, we don't change since we have a custom atc function)
            await addProduct({
                items: [{
                    quantity: 1,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            });

            await openCart();

            // remove loading animation
            this.classList.remove("loading");
        });
    });
}


// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});


// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", openCart);
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");
    // formdata
    let formData = {
        items: []
    };


    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // check if sale enabled
    if (cartSettings.activate_sale) {


        // SALE: If 1 variety packs are in the cart, add 1 more (discount will be automatic to make free)
        let varietyPackID = 9321766682930;
        let varietyPackVariantID = 48595414024498;

        // check if there are 1 variety packs in the cart
        let varietyPackInCart = cart.items.filter(item => item.product_id === varietyPackID);
        if (varietyPackInCart.length === 1) {
            let varietyPackInCartCount = varietyPackInCart[0].quantity;

            // if there is 1 variety pack in the cart and it's not free, add another
            if (varietyPackInCartCount === 1 && varietyPackInCart[0].final_line_price > 0) {
                // add to cart
                await addProduct({
                    items: [{
                        id: varietyPackVariantID,
                        quantity: 1
                    }]
                });
            }
        }

    }


    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));
